import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { logoutUser } from "../services/authService";

function IdleTimer({ timeout = 30 * 60 * 1000 }) {
  const dispatch = useDispatch();
  const isLoggedOut = useSelector((state) => state.user.isLoggedOut);
  useEffect(() => {
    let timer;
    const resetTimer = () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        // Auto logout after inactivity
        if (!isLoggedOut) {
          // Only logout if user is currently logged in
          logoutUser(dispatch);
        }
      }, timeout);
    };

    // Events that reset the timer
    const events = [
      "mousemove",
      "mousedown",
      "keydown",
      "scroll",
      "touchstart",
    ];

    events.forEach((event) => window.addEventListener(event, resetTimer));

    resetTimer(); // start timer on mount

    return () => {
      clearTimeout(timer);
      events.forEach((event) => window.removeEventListener(event, resetTimer));
    };
  }, [dispatch, timeout, isLoggedOut]);

  return null; // no UI
}

export default IdleTimer;
